module.exports = __webpack_public_path__ + "img/charm_6.3aec1648.svg";